type Size = 'sm' | 'md' | 'lg';

export function Spinner({ size = 'md' }: { size?: Size }) {
  return (
    <span className={`ds-spinner${size !== 'md' ? ` ds-spinner--${size}` : ''}`} aria-hidden />
  );
}
